"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.percentCalc = percentCalc;

function percentCalc(previous, current) {
  let previous_price = Number(previous);
  let current_price = Number(current);
  let result = current_price * 100 / previous_price;
  return 100 - Math.floor(result);
}